import { Component } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { MessageService } from 'primeng/api';
import { NewsArticle } from '../../Models/News/News';
import { AuthService } from '../../Services/auth.service';
import { BaseApiService } from '../../Services/base-api.service';
import { BaseComponent } from '../../Base/base/base.component';
import { takeUntil, finalize } from 'rxjs';


@Component({
  selector: 'app-news-detail',
  templateUrl: './news-detail.component.html',
  styleUrls: ['./news-detail.component.css'],standalone:false
})
export class NewsDetailComponent  extends BaseComponent{
 //declarations
 loading:boolean=false;
 news!:NewsArticle;
 itemId!:string
 providername:string='France 24'
 logoprovider:string='https://www.france24.com/favicon.ico'
 userRole:string=''
 //Initilization
 constructor
 (
      private api:BaseApiService,
      private messageService:MessageService,
      private route: ActivatedRoute,
      private sanitizer: DomSanitizer,
      private auth :AuthService
 )
 {
     super();
     this.userRole=this.auth.getRoles().toString()
 }

 //Getting news
 GetNotifications(id:string)
 {
   this.loading=true;
   this.api.read(`WebScrapper/GetDetailNews?Id=${id}`)
   .pipe
   (
      takeUntil(this.destroy$),
      finalize(() => {
        this.loading = false;
      })
   )
   .subscribe
   (

    {
        next:(response)=>{
          this.news     = response;
          this.loading  = false;
        },
        error:(
          error
        )=>{
   
          this.loading=false;
          this.messageService.add({ severity: 'error', summary: 'Error', detail: error });
        }
    }
   )
 }


 getLogo(url:string)
 {
    const con = this.api.getNewsProviderDetails(url)
    if(con){
      this.logoprovider=con.logoUrl;
      return this.logoprovider;
    }
    return this.logoprovider;
 }

 sanitizeHtml(htmlContent: string): SafeHtml {
   return this.sanitizer.bypassSecurityTrustHtml(htmlContent);
 }

 sanitizeHtmlWithImageFix(html: string) {
  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = html;

  const images = tempDiv.querySelectorAll('img');
  let imageSrc = '';

  images.forEach((img: HTMLImageElement, index: number) => {
    img.style.maxWidth = '100%';
    img.style.height = 'auto';
    img.style.objectFit = 'cover';
    img.classList.add('img-fluid', 'rounded-2', 'shadow', 'my-2');

    if (index === 0) {
      imageSrc = img.src;
      img.remove(); // Optional: remove first image from content
    }
  });

  return {
    sanitizedHtml: this.sanitizer.bypassSecurityTrustHtml(tempDiv.innerHTML),
    imageSrc: imageSrc
  };
}



 getFaviconUrl(rssUrl: string): string {
   try {
     // Extract the base domain from the RSS feed URL
     const url = new URL(rssUrl);
     const domain = url.origin; // Get the base domain (e.g., https://www.bfmtv.com)

     // Construct the favicon URL (assuming it's located at /favicon.ico)
     return `${domain}/favicon.ico`;
   } catch (error) {
     // Return a default favicon in case of an error
     return 'assets/icons/default-favicon.png';
   }
 }


 getSiteName(url: string): string {
   try {
     // Create a URL object from the provided URL
     const urlObj = new URL(url);

     // Get the hostname (e.g., www.bfmtv.com)
     let hostname = urlObj.hostname;

     // Remove common subdomains like 'www.'
     if (hostname.startsWith('www.')) {
       hostname = hostname.replace('www.', '');
     }

     // Capitalize the first letter of each word to create a clean name
     const siteName = hostname.split('.')[0]; // Take the main part of the domain
     return this.capitalizeWords(siteName); // Capitalize the first letter of the name
   } catch (error) {
     // In case of error, return a default name or an empty string
     return 'Unknown Site';
   }
 }

 // Helper function to capitalize words
 private capitalizeWords(name: string): string {
   return name.charAt(0).toUpperCase() + name.slice(1);
 }

 //Calling
 ngOnInit(): void
 {

   this.route.params.subscribe(params => {
     this.itemId = params['id'];
     if(this.itemId!=null){
       this.providername=this.itemId;
       this.GetNotifications(this.itemId);
     }
   });
 }

}
